<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" clearable v-model="terminalNum" placeholder="终端主机号" style="width: 200px; margin-right: 3px;"></Input>
      <DatePicker type="daterange" size="small" :start-date="new Date()" placement="bottom-end"
                  placeholder="定位时间范围" style="width: 200px;margin-right: 3px;"
                  v-model="dateFilter"></DatePicker>
      <Button type="primary" size="small" style="margin-right: 3px;" :disabled="listLoadding" @click="onFilterClick">查询</Button>
      <Button type="primary" size="small" style="margin-right: 3px;" :disabled="listLoadding" @click="onExportExcelClick">导出</Button>
      <Button type="primary" size="small" style="margin-right: 3px;" :disabled="listLoadding" @click="onExportSrcExcelClick">导出原始数据</Button>
    </Row>
<!--    <Row style="margin-top: 3px;">-->
<!--      <label>删除数据</label>-->
<!--      <DatePicker type="datetime" size="small" placeholder="选择时间" style="width: 200px;margin-right: 3px;" v-model="deleteTime"></DatePicker>-->
<!--      <Button type="primary" size="small" style="margin-right: 3px;" :disabled="deleting" @click="onDeleteClick">删除</Button>-->
<!--    </Row>-->
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :data="content" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px"></Page>
      </div>
    </Row>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '../../store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { explainAlarmSign, explainState } from '@/libs/jt808util'

export default {
  name: 'locatehistorys',
  components: {

  },
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      deleteTime: null,
      deleting: false,

      dateFilter: [],
      startDate: null,
      endDate: null,

      pageFilter: 30,
      pagesizeopts: [30, 50, 100, 200],
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,
      terminalNum: null,
      columns: [
        {
          title: '终端主机号',
          resizable: true,
          key: 'terminalNum',
          ellipsis: 'true',
          width: 110
        },
        {
          title: '定位时间',
          resizable: true,
          key: 'locateDatetimeLongValue',
          sortable: 'custom',
          ellipsis: 'true',
          width: 160,
          render: function (h, params) {
            if (params.row.locateDatetimeLongValue) {
              let d = new Date(params.row.locateDatetimeLongValue)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '状态',
          resizable: true,
          key: 'state',
          ellipsis: 'true',
          width: 600,
          render: function (h, params) {
            if (params.row.state != null) {
              let s = explainState(params.row.state)
              let ds = []
              s.forEach(item => {
                if (item === 'ACC开') {
                  if (params.row.speed === 0) {
                    ds.push(h('label', { style: { color: 'orange' } }, item + ','))
                  } else {
                    ds.push(h('label', { style: { color: 'green' } }, item + ','))
                  }
                } else if (item === 'ACC关') {
                  ds.push(h('label', { style: { color: 'red' } }, item + ','))
                } else if (item === '定位') {
                  ds.push(h('label', { style: { color: 'green' } }, item + ','))
                } else if (item === '未定位') {
                  ds.push(h('label', { style: { color: 'red' } }, item + ','))
                } else {
                  ds.push(h('label', item + ','))
                }
              })
              return h('div', ds)
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '报警',
          resizable: true,
          key: 'alarmSign',
          ellipsis: 'true',
          width: 200,
          render: function (h, params) {
            if (params.row.alarmSign !== 0) {
              return h('div', explainAlarmSign(params.row.alarmSign))
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '速度(km/h)',
          resizable: true,
          key: 'speed',
          ellipsis: 'true',
          width: 110,
          render: function (h, params) {
            if (params.row.speed !== 0) {
              return h('div', params.row.speed / 10)
            } else {
              return h('div', params.row.speed)
            }
          }
        },
        {
          title: '累计里程(km)',
          resizable: true,
          key: 'mileage',
          ellipsis: 'true',
          width: 140,
          render: function (h, params) {
            if (params.row.mileage !== 0) {
              return h('div', params.row.mileage / 10)
            } else {
              return h('div', params.row.mileage)
            }
          }
        },
        {
          title: '补传',
          resizable: true,
          key: 'afterUpload',
          ellipsis: 'true',
          width: 110,
          render: function (h, params) {
            if (params.row.afterUpload) {
              return h('label', { style: { color: 'red' } }, '是')
            } else {
              return h('label', '否')
            }
          }
        },
        {
          title: '位置数据类型',
          resizable: true,
          key: 'positionDataType',
          ellipsis: 'true',
          width: 110,
          render: function (h, params) {
            if (params.row.positionDataType === 0) {
              return h('label', { style: { color: 'red' } }, '正常位置批量汇报')
            } else if (params.row.positionDataType === 1) {
              return h('label', { style: { color: 'red' } }, '盲区补报')
            } else if (params.row.positionDataType === 2) {
              return h('label', '正常定位')
            } else if (params.row.positionDataType === 3) {
              return h('label', '未知')
            }
          }
        },
        {
          title: '经度',
          resizable: true,
          key: 'longitude',
          ellipsis: 'true',
          width: 110
        },
        {
          title: '纬度',
          resizable: true,
          key: 'latitude',
          ellipsis: 'true',
          width: 110
        },
        {
          title: '无线通信网络信号强度',
          resizable: true,
          key: 'rssi',
          ellipsis: 'true',
          width: 110
        },
        {
          title: '定位卫星数',
          resizable: true,
          key: 'gnssCount',
          ellipsis: 'true',
          width: 110
        },
        {
          title: '接收时间',
          resizable: true,
          key: 'recvDatetimeLongValue',
          sortable: 'custom',
          ellipsis: 'true',
          width: 160,
          render: function (h, params) {
            if (params.row.recvDatetimeLongValue) {
              let d = new Date(params.row.recvDatetimeLongValue)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onExportSrcExcelClick () {
      if (!(this.startDate && this.endDate)) {
        this.$Message.error('缺少查询时间')
        return
      }

      if (!this.terminalNum) {
        this.$Message.error('缺少主机号')
        return
      }

      let url = '/api/history/locatehistory/exportsrcexcel/' + this.terminalNum + '/' + this.startDate + '/' + this.endDate
      window.location.href = url
    },
    onExportExcelClick () {
      let sortParam = null
      let queryParams = []

      // if (this.sort) {
      //   sortParam = genSortParam(this.sort.name, this.sort.asc)
      // }
      // if (this.terminalNum) {
      //   queryParams.push(genQueryParam('terminalNum', 'EQSTR', this.terminalNum))
      // }
      // if (this.startDate && this.endDate) {
      //   queryParams.push(genQueryParam('locateDatetimeLongValue', 'BTDT', this.startDate, this.endDate))
      // }else{
      //   this.$Message.error('缺少查询时间')
      //   return
      // }
      //
      // let urlparams = {
      //   q: queryParams,
      //   sort: sortParam
      // }
      if (!(this.startDate && this.endDate)) {
        this.$Message.error('缺少查询时间')
        return
      }

      if (!this.terminalNum) {
        this.$Message.error('缺少主机号')
        return
      }

      let url = '/api/history/locatehistory/exportexcel/' + this.terminalNum + '/' + this.startDate + '/' + this.endDate
      window.location.href = url
    },
    onDeleteClick () {
      if (!this.deleteTime) {
        this.$Message.error('无效删除时间')
        return
      }
      let deleteTime = this.deleteTime.Format('yyyy-MM-dd hh:mm:ss')
      this.deleting = true
      store.dispatch('LocateHistoryServ_RemoveBefore', {
        params: { selectDatetime: deleteTime },
        urlparams: null
      }).then(() => {
        this.deleting = false
        this.$Message.success('删除成功')
      }).catch(err => {
        this.deleting = false
        this.$Message.error(err)
      })
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onFilterClick () {
      if (this.dateFilter.length == 0) {
        this.startDate = null
        this.endDate = null
        this.setPage(1)
        return
      }
      if (this.dateFilter[0] === '' || this.dateFilter[1] === '') {
        this.startDate = null
        this.endDate = null
        this.setPage(1)
        return
      }
      let startDate = this.dateFilter[0]
      let endDate = this.dateFilter[1]
      this.startDate = new Date(startDate).Format('yyyy-MM-dd 00:00:00')
      this.endDate = new Date(endDate).Format('yyyy-MM-dd 23:59:59')
      this.setPage(1)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    setPage (page) {
      this.pageIndex = page
      this.listLoadding = true

      let sortParam = null
      let queryParams = []

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }
      if (this.terminalNum) {
        queryParams.push(genQueryParam('terminalNum', 'EQSTR', this.terminalNum))
      }
      if (this.startDate && this.endDate) {
        queryParams.push(genQueryParam('locateDatetimeLongValue', 'BTDT', this.startDate, this.endDate))
      }

      store.dispatch('LocateHistoryServ_GetPage', {
        params: null,
        urlparams: {
          ps: this.pageFilter,
          p: page,
          q: queryParams,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    }
  },
  computed: {
    totalElements () {
      if (store.getters.get_LocateHistory_GetPageResult) {
        return store.getters.get_LocateHistory_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_LocateHistory_GetPageResult) {
        return store.getters.get_LocateHistory_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_LocateHistory_GetPageResult) {
        return store.getters.get_LocateHistory_GetPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 160
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
